const PosTransactionTypes: any = {
  ALL: {
    description: 'All POS transactions',
    value: 'POS',
  },
  PIN: {
    description: 'PIN transactions only',
    value: 'POS_PIN',
  },
  SIGNATURE: {
    description: 'Signature transactions only',
    value: 'POS_SIGNATURE',
  },
  CC: {
    description: 'Credit Card purchases only',
    value: 'CC',
  },
  ALL_CC: {
    description: 'All POS transactions and CC purchases',
    value: 'POS_CC',
  },
  PIN_CC: {
    description: 'PIN transactions and CC purchases',
    value: 'POS_PIN_CC',
  },
  SIGNATURE_CC: {
    description: 'Signature transactions and CC purchases',
    value: 'POS_SIGNATURE_CC',
  },
};

export default PosTransactionTypes;
